import { Expose } from "class-transformer";

export class CreateRoleDto {
  @Expose()
  name: string;
}
